// extracted by mini-css-extract-plugin
export default {"changeDisclaimer":"OL-z","cltLink":"PL-z","shippingDisclaimer":"QL-z"};